import React from 'react';

export default function Privacy() {
  return (
    <div className="page">
      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy explains how Dex Labs Ltd. ("we", "us", or "our") collects, uses, and protects your personal data when you use the Dex mobile application and related services (collectively, the “Service”). By using Dex, you agree to the practices outlined below.
      </p>

      <ol>
        <li>
          <strong>Information We Collect</strong><br />
          We collect the following types of information:
          <ul>
            <li>
              <strong>Account Information:</strong> When you register, we collect your email, username, and optionally, a display name or profile picture.
            </li>
            <li>
              <strong>Gameplay Data:</strong> Song choices, votes, battle history, and match outcomes.
            </li>
            <li>
              <strong>Device Information:</strong> Device type, operating system, and crash reports for debugging and performance monitoring.
            </li>
            <li>
              <strong>Third-Party Integrations:</strong> If you connect your Spotify, Apple Music, or YouTube account, we access playback permissions and public profile metadata, never your login credentials.
            </li>
          </ul>
        </li>

        <li>
          <strong>How We Use Your Information</strong><br />
          We use your data to:
          <ul>
            <li>Provide core features of the Dex app</li>
            <li>Track game progress, stats, and leaderboards</li>
            <li>Detect and prevent cheating or abuse</li>
            <li>Improve the app and personalize your experience</li>
            <li>Communicate with you about updates or support</li>
          </ul>
        </li>

        <li>
          <strong>Data Sharing and Disclosure</strong><br />
          We do <strong>not</strong> sell your personal data. We only share data in these cases:
          <ul>
            <li>With trusted service providers (e.g. Firebase, Google Cloud) to host and process data</li>
            <li>When legally required by law enforcement or government authorities</li>
            <li>To investigate violations of our Terms & Conditions</li>
          </ul>
        </li>

        <li>
          <strong>Cookies and Analytics</strong><br />
          We use basic analytics tools to understand how players use Dex. This includes anonymous data like screen views and session durations. We do not use third-party advertising cookies or cross-site tracking.
        </li>

        <li>
          <strong>Your Rights</strong><br />
          Depending on your jurisdiction, you may have rights to:
          <ul>
            <li>Access the data we hold about you</li>
            <li>Request correction or deletion of your data</li>
            <li>Withdraw consent at any time (e.g., disconnect Spotify)</li>
          </ul>
          To exercise any of these rights, contact us at the address below.
        </li>

        <li>
          <strong>Data Retention</strong><br />
          We retain your account and gameplay data while your account is active. If you delete your account, most data is permanently erased within 30 days, except where required by law or for security purposes.
        </li>

        <li>
          <strong>Children’s Privacy</strong><br />
          Dex is intended for users aged 13 and older. If we become aware that a child under 13 has provided personal data without parental consent, we will delete such information promptly.
        </li>

        <li>
          <strong>Security</strong><br />
          We take data protection seriously. All data is encrypted in transit and at rest using secure Google Cloud and Firebase infrastructure. Access is limited to authorized personnel only.
        </li>

        <li>
          <strong>Changes to This Policy</strong><br />
          We may update this Privacy Policy from time to time. If we make significant changes, we will notify you via in-app alerts or email. Your continued use of Dex means you accept the updated policy.
        </li>

        <li>
          <strong>Contact Us</strong><br />
          If you have any questions or concerns about your privacy, contact us at:<br />
          <br />
          Dex Labs Ltd.<br />
          71-75 Shelton Street<br />
          London, WC2H 9JQ<br />
          United Kingdom
        </li>
      </ol>
    </div>
  );
}
